import TranslatedText from "@components/items/display/TranslatedText";
import SocialMediaIcon from "@components/items/display/SocialMediaIcon";
import { ShadcnButton } from "@components/items/display/ShadcnButton";
import { Separator } from "@ui/separator";
import WajeezLogo from "@components/items/common/WajeezLogo";
import { useLanguage } from "@modules/localizations/LanguageContext";
import { translate } from "@modules/localizations/translate";

const Footer = () => {
  const { language } = useLanguage();

  const footerItems: { title: string; path: string }[] = [
    // { title: "اتصل بنا", path: "" },
    // { title: "مركز خدمة العملاء", path: "" },
    // { title: "تطبيقات", path: "" },
    // { title: "قم بالإبلاغ", path: "" },
    {
      title: "الشروط والأحكام",
      path: "https://wajeez.com/tos?lang=ar",
    },
    {
      title: "سياسة الخصوصية",
      path: "https://wajeez.com/privacy?lang=ar",
    },
  ];

  const socialMediaIcons = [
    { link: "https://x.com/wajeezapp", path: "x.svg", type: "svg" },
    {
      link: "https://www.instagram.com/wajeezapp",
      path: "instagram.png",
      type: "img",
    },
    {
      link: "https://www.facebook.com/Wajeezapp",
      path: "facebook.png",
      type: "img",
    },
  ];

  return (
    <footer className="mt-auto bg-dark_background sm:h-[291px]">
      <div className="flex w-full items-center justify-start pb-3 sm:justify-center">
        {footerItems?.map((item, index) => (
          <a key={index} href={item.path}>
            <ShadcnButton
              key={index}
              className="bg-transparent px-5 py-6 hover:bg-transparent dark:bg-transparent dark:hover:bg-transparent"
            >
              <div className="text-nowrap text-[16px] font-medium text-white">
                {item?.title}
              </div>
            </ShadcnButton>
          </a>
        ))}
      </div>
      <div className="flex w-full flex-col items-start justify-center gap-8 sm:flex-row sm:items-center sm:gap-16">
        <div className="flex items-center justify-start">
          <a href={"/login"}>
            <WajeezLogo width={100} lang={language} />
          </a>
          <div className="w-[238px] text-[10px] leading-normal text-[#999999] ltr:text-left rtl:text-right">
            وجيز تطبيق هاتفي يوفّر محتوى صوتي في ملخصات الكتب، والروايات،
            والبودكاست، اقرأ كتاب كل 15 دقيقة وكُن نسخة أفضل من نفسك في زمن
            قصير!
          </div>
        </div>
        <Separator
          orientation="vertical"
          className="hidden h-16 w-[2px] bg-[#999999] sm:block"
        />
        <div className="flex flex-col items-center justify-center gap-6 place-self-center">
          <div className="text-right font-[14px] text-[#999999]">
            تابعنا على السوشال ميديا
          </div>
          <div className="flex w-[135px] justify-between">
            {socialMediaIcons?.map((icon, index) => (
              <div
                className="flex h-[35px] w-[35px] items-center justify-center rounded-full bg-[#898A8D]"
                key={index}
              >
                <SocialMediaIcon
                  type={icon?.type}
                  link={icon?.link}
                  icon={`/assets/icons/${icon?.path}`}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center py-6">
        <div className="text-[16px] font-medium text-[#999999]">
          جميع الحقوق محفوظة ل wajeez
        </div>
      </div>
    </footer>
  );
};

export default Footer;
